/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetInsuranceOverViewResponse,
  GetInsurancePolicyItemResponse
} from './schema'



export const utxInsuranceGetInsuranceOverview = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetInsuranceOverViewResponse>> => {
    return axios.get(
      `/insurance/overview`,options
    );
  }


export const getUtxInsuranceGetInsuranceOverviewQueryKey = () => [`/insurance/overview`];

    
export type UtxInsuranceGetInsuranceOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof utxInsuranceGetInsuranceOverview>>>
export type UtxInsuranceGetInsuranceOverviewQueryError = AxiosError<unknown>

export const useUtxInsuranceGetInsuranceOverview = <TData = Awaited<ReturnType<typeof utxInsuranceGetInsuranceOverview>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxInsuranceGetInsuranceOverview>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxInsuranceGetInsuranceOverviewQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxInsuranceGetInsuranceOverview>>> = ({ signal }) => utxInsuranceGetInsuranceOverview({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxInsuranceGetInsuranceOverview>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxInsuranceGetInsurancePolicies = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetInsurancePolicyItemResponse[]>> => {
    return axios.get(
      `/insurance/policies`,options
    );
  }


export const getUtxInsuranceGetInsurancePoliciesQueryKey = () => [`/insurance/policies`];

    
export type UtxInsuranceGetInsurancePoliciesQueryResult = NonNullable<Awaited<ReturnType<typeof utxInsuranceGetInsurancePolicies>>>
export type UtxInsuranceGetInsurancePoliciesQueryError = AxiosError<unknown>

export const useUtxInsuranceGetInsurancePolicies = <TData = Awaited<ReturnType<typeof utxInsuranceGetInsurancePolicies>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxInsuranceGetInsurancePolicies>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxInsuranceGetInsurancePoliciesQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxInsuranceGetInsurancePolicies>>> = ({ signal }) => utxInsuranceGetInsurancePolicies({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxInsuranceGetInsurancePolicies>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Request to open insurance account
 */
export const utxInsuranceOpenInsuranceAccount = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/insurance/open-account`,undefined,options
    );
  }



    export type UtxInsuranceOpenInsuranceAccountMutationResult = NonNullable<Awaited<ReturnType<typeof utxInsuranceOpenInsuranceAccount>>>
    
    export type UtxInsuranceOpenInsuranceAccountMutationError = AxiosError<unknown>

    export const useUtxInsuranceOpenInsuranceAccount = <TError = AxiosError<unknown>,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxInsuranceOpenInsuranceAccount>>, TError,TVariables, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxInsuranceOpenInsuranceAccount>>, TVariables> = () => {
          

          return  utxInsuranceOpenInsuranceAccount(axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxInsuranceOpenInsuranceAccount>>, TError, TVariables, TContext>(mutationFn, mutationOptions)
    }
    